const { mapStateToProps } = require('@reverbdotcom/discovery-ui');

const ShippingProtectionInput = require('../shipping_protection_input');
const {
  store: ShippingLabelStore,
  actions: ShippingLabelActions,
} = require('../shipping_label_form_module');

function mapper() {
  const { insurancePolicy, shipment } = ShippingLabelStore.getState();
  let showDisabled = false;
  let cannotInsure = false;
  let insuranceRequired = false;
  let shipmentInsured = true;
  let formattedInsuranceCost = '$0';

  if (insurancePolicy && shipment) {
    showDisabled = insurancePolicy.insuranceRequired || insurancePolicy.cannotInsure;
    cannotInsure = insurancePolicy.cannotInsure;
    formattedInsuranceCost = insurancePolicy.formattedInsuranceCost;
    insuranceRequired = insurancePolicy.insuranceRequired;
    shipmentInsured = shipment.insured;
  }

  return {
    showDisabled,
    cannotInsure,
    insuranceRequired,
    shipmentInsured,
    formattedInsuranceCost,
    toggleShipmentInsurance: ShippingLabelActions.toggleShipmentInsurance,
  };
}

module.exports = mapStateToProps({
  mapper, stores: [ShippingLabelStore],
})(ShippingProtectionInput, 'ShippingProtectionInput');



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/containers/shipping_protection_input_container.jsx